import { useEffect } from 'react';
import useInView from '../hooks/useInView';
import LazyImage from './LazyImage';
import './ContactGame.css';

function HandPosition({
  handPosition,
  setHandPosition,
  windowNum,
  selectedThrowItem,
  isMobile,
}) {
  const [containerRef, inView] = useInView({ rootMargin: '400px 0px' });

  useEffect(() => {
    if (!isMobile) {
      const handleKeyDown = (event) => {
        if (event.key === 'ArrowLeft') {
          setHandPosition((prev) => Math.max(prev - 1, 0));
        } else if (event.key === 'ArrowRight') {
          setHandPosition((prev) => Math.min(prev + 1, 2));
        }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [setHandPosition, isMobile]);

  return (
    <div className="window-wrapper" ref={containerRef}>
      {[0, 1, 2].map((num) => (
        <div
          key={num}
          className={`window ${['left', 'center', 'right'][num]}-window`}
          onClick={() => isMobile && setHandPosition(num)}
        >
          {inView && (
            <>
              <LazyImage
                alt="face"
                src={`/images/m${num + 1}.png`}
                className={`face ${windowNum === num ? 'visible' : ''}`}
              />
              <LazyImage
                alt="hand"
                src={`/images/hand-${selectedThrowItem || 'tomato'}.png`}
                className={`hand-indicator ${handPosition === num ? 'visible' : ''}`}
              />
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default HandPosition;
